import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useRestaurant } from '../../modules/restaurant/pages/RestaurantSelection/RestaurantContext';
import LoadingScreen from '../../modules/shared/components/LoadingScreen';
import { getStoredRestaurantSelection } from '../../modules/shared/utils/restaurantCheck';

/**
 * Skips restaurant picker and locks the session to a single restaurant.
 * Preserves table from URL/storage when present.
 */
export default function FixedRestaurantGate({ restaurantId, defaultTable = 'N/A' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { restaurantId: currentRestaurantId, setRestaurantAndTable } = useRestaurant();
  const didLockRef = useRef(false);

  useEffect(() => {
    if (!restaurantId || didLockRef.current) return;
    didLockRef.current = true;

    const params = new URLSearchParams(location.search || '');
    const urlTable = params.get('table');
    const stored = getStoredRestaurantSelection();
    const table = urlTable || stored?.tableNumber || defaultTable;

    if (currentRestaurantId !== restaurantId || stored?.tableNumber !== table) {
      setRestaurantAndTable(restaurantId, table);
    }

    const nextSearch = params.toString() ? `?${params.toString()}` : '';
    navigate(`/home${nextSearch}`, { replace: true });
  }, [
    restaurantId,
    defaultTable,
    currentRestaurantId,
    setRestaurantAndTable,
    navigate,
    location.search,
  ]);

  return <LoadingScreen message="Loading..." />;
}
